import React from 'react';
import {bool, func} from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import UIModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }
}));

export default function Modal({active, onClose, children}) {
  const classes = useStyles();

  return (
    <UIModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={active}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={active}>
        {children}
      </Fade>
    </UIModal>
  )
}

Modal.propTypes = {
  active: bool,
  onClose: func
}
